import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip,
    Button
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import StatusBadge from "components/badge/StatusBadge";

const ViewLeads = (props) => {
    const { open, handleClose, rowData } = props;

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mt: 0.5,
    };

    const formatINR = (value) => {
        if (!value && value !== 0) return "N/A";
        return Number(value).toLocaleString("en-IN");
    };

    return (
        <>
            <Dialog
                open={open}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        overflowX: "hidden"
                    },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                }}>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View Lead Details
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Card
                        elevation={0}
                        sx={{
                            borderRadius: "3px",
                            border: "1px solid #e5e7eb",
                            backgroundColor: "#fff",
                            p: 2,
                        }}
                    >
                        {/* Header */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1,
                            }}
                        >
                            <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                                Lead Information
                            </Typography>
                        </Box>

                        <Divider sx={{ mb: 2 }} />

                        <CardContent sx={{ pt: 0 }}>
                            <Grid container spacing={2}>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Name:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.name ?? "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Asset Name:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.assetName ? rowData?.assetName : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Asset Type:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.assetType ? rowData?.assetType : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Area In Sqft:</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.area)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Expectation Rental Rate:</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.expectationRentalRate)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Status:</Typography>
                                    <Typography sx={valueStyle}>
                                        <StatusBadge status={rowData?.status} />
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Type:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.type ? rowData?.type : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Site Visit Date:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.siteVisitDate ? moment.utc(rowData?.siteVisitDate).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Start Date:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.startDate ? moment.utc(rowData?.startDate).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Source:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.source ? rowData?.source : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Proposal Status:</Typography>
                                    <Typography sx={valueStyle}><StatusBadge status={rowData?.proposalStatus} /></Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Proposal Date:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.proposalDate ? moment.utc(rowData?.proposalDate).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Proposed Rental Base:</Typography>
                                    <Typography sx={valueStyle}>{formatINR(rowData?.proposedRentalBase)}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Proposed Rental CAM:</Typography>
                                    <Typography sx={valueStyle}>
                                        <Typography sx={valueStyle}>{formatINR(rowData?.proposedRentalCam)}</Typography>
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Proposed Rental TI:</Typography>
                                    <Typography sx={valueStyle}>
                                        <Typography sx={valueStyle}>{formatINR(rowData?.proposedRentalTi)}</Typography>
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Current Stage:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.currentStage ? rowData?.currentStage : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>LOI Date:</Typography>
                                    <Typography sx={valueStyle}>
                                        {rowData?.loiDate ? moment.utc(rowData?.loiDate).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Time to Deal:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.timeToDeal ? rowData?.timeToDeal : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Last Action:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.lastAction ? rowData?.lastAction : "N/A"}</Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                    <Typography sx={labelStyle}>Next Steps:</Typography>
                                    <Typography sx={valueStyle}>{rowData?.nextSteps ? rowData?.nextSteps : "N/A"}</Typography>
                                </Grid>

                            </Grid>
                        </CardContent>
                    </Card>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ViewLeads;